define('src/routes',[
    'jquery',
    'mustache'
], function($, Mustache) {

    var Routes = {
        // TODO remove debug
        debug: {
            info: "debug/",
            // full: "debug/full/",
        },
        // calendar:{
        //     activity: "activity/"
        // },
        supervisor: {
            member: {
                menu: "#/supervisor/member/",
                page: "#/supervisor/member/{{id}}/",
                sub: {
                    calendar: "calendar/",
                    graphs: "graphs/",
                    goals: "goals/",
                    messages: "messages/",
                    notes: "notes/"
                }
            },
            messages: {
                menu: "#/supervisor/messages/",
            },
            reports: {
                menu: "#/supervisor/reports/",
            },
            templates: {
                menu: "#/supervisor/templates/",
            },
            forms: {
                menu: "#/supervisor/forms/",
            },
            forums: {
                menu: "#/supervisor/forums/",
            },
            settings: {
                menu: "#/supervisor/settings/",
                advanced: "#/supervisor/settings/advanced/",
            },
        },

        render: function() {
            return Mustache.render.apply(Mustache, arguments);
        }
    };


    return Routes;
});

